export default __webpack_public_path__ + "static/IvarDisplay-Regular-c9ae7d064a51e98a357a4abbd6626c77.eot";